var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocs = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  id: "docs"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_0_223",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  id: "Bounding box",
  width: 20,
  height: 20,
  fill: "#D9D9D9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_0_223)"
}, /*#__PURE__*/React.createElement("path", {
  id: "docs_2",
  d: "M5.83333 18.3333C5.375 18.3333 4.98264 18.1701 4.65625 17.8438C4.32986 17.5174 4.16667 17.125 4.16667 16.6667V3.33333C4.16667 2.875 4.32986 2.48264 4.65625 2.15625C4.98264 1.82986 5.375 1.66667 5.83333 1.66667H10.9792C11.2014 1.66667 11.4132 1.70833 11.6146 1.79167C11.816 1.875 11.9931 1.99306 12.1458 2.14583L15.3542 5.35417C15.5069 5.50694 15.625 5.68403 15.7083 5.88542C15.7917 6.08681 15.8333 6.29861 15.8333 6.52083V16.6667C15.8333 17.125 15.6701 17.5174 15.3438 17.8438C15.0174 18.1701 14.625 18.3333 14.1667 18.3333H5.83333ZM9.16667 3.33333H5.83333V16.6667H14.1667V8.33333H11.6667C10.9722 8.33333 10.3819 8.09028 9.89583 7.60417C9.40972 7.11806 9.16667 6.52778 9.16667 5.83333V3.33333ZM10.8333 3.33333V5.83333C10.8333 6.06944 10.9132 6.26736 11.0729 6.42708C11.2326 6.58681 11.4306 6.66667 11.6667 6.66667H14.1667V6.52083L10.9792 3.33333H10.8333ZM8.33333 15.8333C8.09722 15.8333 7.89931 15.7535 7.73958 15.5937C7.57986 15.434 7.5 15.2361 7.5 15C7.5 14.7639 7.57986 14.566 7.73958 14.4062C7.89931 14.2465 8.09722 14.1667 8.33333 14.1667H10C10.2361 14.1667 10.434 14.2465 10.5938 14.4062C10.7535 14.566 10.8333 14.7639 10.8333 15C10.8333 15.2361 10.7535 15.434 10.5938 15.5937C10.434 15.7535 10.2361 15.8333 10 15.8333H8.33333ZM8.33333 12.5C8.09722 12.5 7.89931 12.4201 7.73958 12.2604C7.57986 12.1007 7.5 11.9028 7.5 11.6667C7.5 11.4306 7.57986 11.2326 7.73958 11.0729C7.89931 10.9132 8.09722 10.8333 8.33333 10.8333H11.6667C11.9028 10.8333 12.1007 10.9132 12.2604 11.0729C12.4201 11.2326 12.5 11.4306 12.5 11.6667C12.5 11.9028 12.4201 12.1007 12.2604 12.2604C12.1007 12.4201 11.9028 12.5 11.6667 12.5H8.33333Z",
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/docs.339e9b98cbf7cfe93f4e25af8e2d72a3.svg";